var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"justify-content-center"},[_c('v-col',{staticClass:"text-center pt-0",attrs:{"sm":"12"}},[_c('youtube',{key:_vm.content.url,ref:"youtube",attrs:{"video-id":_vm.videoId,"player-width":_vm.content.settings.width,"player-height":_vm.content.settings.height},on:{"ready":_vm.videoReady,"cued":_vm.videoReady}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }